module.exports = __webpack_public_path__ + "img/ic_arrow_down.895f3015.svg";